import { Component } from '@angular/core'
import { NavigationEnd, Router, RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { TranslateService } from '@ngx-translate/core'
import { resolveInitialLang } from '@services/language.util'
import { CookieConsentService } from '@services/cookie-consent.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class AppComponent {
  title = 'frontend'
  showHeaderFooter = true

  constructor(
    private router: Router,
    private translate: TranslateService,
    private cookieConsentService: CookieConsentService
  ) {
    const initialLang = resolveInitialLang()

    this.translate.addLangs(['sr', 'en'])
    this.translate.setDefaultLang(initialLang)
    this.translate.use(initialLang)
    document.documentElement.lang = initialLang

    // The app booted, so chunks loaded fine — clear the one-shot reload guard
    // set by GlobalErrorHandler so a future stale-chunk error can recover again.
    sessionStorage.removeItem('kontakta:chunk-reload')

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showHeaderFooter = !event.url.startsWith('/dashboard')
      }
    })
  }

  onActivate() {
    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }
}
